





























































































































































































































import { API } from "@/shared/api";
import { pedido } from "@/shared/dtos/pedido";
import pedidoModule from "@/store/modules/pedido-module";
import usuarioModule from "@/store/modules/usuario-module";
import { Component, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {
    DocumentsHandler: () => import("@/views/Documentos/DocumentsHandler.vue"),
  },
  $_veeValidate: { validator: "new" },
})
export default class FromularioImportacion extends Vue {
  public nombre: string = "";
  public pedido: pedido = new pedido();
  public estados = ["Pendiente", "Procesado", "Enviado", "Cancelado"];

  created() {
    usuarioModule.getmiusuario();
  }

  public get_url() {
    if (usuarioModule.mi_usuario.id_cliente > 0) {
      return {
        url: API.RepositorioInformes + "/documents/" + usuarioModule.mi_usuario.id_cliente,
        url_download: API.webApiBaseRepositoriArchivos + usuarioModule.mi_usuario.id_cliente,
      };
    } else {
      return { url: "", url_download: "" };
    }
  }

  @Watch("pedido.precio_con_iva")
  calcularPorcentajePagado() {
    this.pedido.porcentaje_valor_iva = this.calcularPorcentaje(this.pedido.valor_amazon, this.pedido.precio_con_iva);
  }

  @Watch("pedido.precio_sin_iva")
  calcularPorcentajeSINPagado() {
    this.pedido.porcentaje_valor_sin_iva = this.calcularPorcentaje(this.pedido.valor_amazon, this.pedido.precio_sin_iva);
  }

  @Watch("pedido.valor_amazon")
  valor_amazon() {
    this.pedido.porcentaje_valor_iva = this.calcularPorcentaje(this.pedido.valor_amazon, this.pedido.precio_con_iva);
    this.pedido.porcentaje_valor_sin_iva = this.calcularPorcentaje(this.pedido.valor_amazon, this.pedido.precio_sin_iva);
  }

  @Watch("pedido.porcentaje_iva")
  calcularSinIVA() {
    this.pedido.precio_sin_iva = this.calcularPrecioSinIVA(this.pedido.precio_con_iva, this.pedido.porcentaje_iva);
  }

  calcular_todo() {
    this.calcularSinIVA();
    this.calcularPorcentajePagado();
    this.calcularPorcentajeSINPagado();
  }

  calcularPorcentaje(total: number, pagado: number): number {
    if (total <= 0) return 0;
    const porcentaje = (pagado / total) * 100;
    return parseFloat(porcentaje.toFixed(2));
  }

  calcularPrecioSinIVA(precioConIVA: number, porcentajeIVA: number): number {
    if (porcentajeIVA < 0) return 0;
    const precioSinIVA = precioConIVA / (1 + porcentajeIVA / 100);
    return parseFloat(precioSinIVA.toFixed(2));
  }

  public importarPedido() {
    pedidoModule.importarpedido(this.pedido);
  }

  public cancelar() {
    this.$router.back();
  }
}
